import './style.css';
import ArrowRight from '../../img/ui/ui-arrow-top-right.svg';

const PriceCard = ({ img, title, price, descriptions, onClick }) => {
  const handleKeyDown = (e) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`price__card${onClick ? ' price__card--clickable' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      <div className="price__card-img">
        <img src={img} alt={title} className="price-img" />
      </div>
      <div className="price__card-text">
        <h2 className="price__card-title">{title}</h2>
        <ul className="price__card-bullets flow">
          {descriptions
            .filter((desc) => desc && desc.trim() !== '')
            .map((desc, idx) => (
              <li key={idx}>{desc}</li>
            ))}
        </ul>
      </div>
      {price && (
        <div className="price__card-price-btn">
          {price}
          <img src={ArrowRight} alt="" aria-hidden="true" />
        </div>
      )}
    </div>
  );
};
 
export default PriceCard;